import bugsnag from '@bugsnag/js';

if(process.env.NODE_ENV === 'production') {
  bugsnag.start('9f17b291a8a3869ce535ff629d3d69f1')
}
